export default __webpack_public_path__ + "static/media/warning--dual-lanes-turn-left-or-right--g3.bf437251.png";